import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import('@/views/index'),
        meta: {title: '首页', Auth: true}
    },
    {
        path: '/family/:id',
        component: () => import('@/views/family'),
        meta: {title: '族谱', Auth: true}
    }, {
        path: '/login',
        component: () => import('@/views/login'),
        meta: {title: '登录'}
    },
     {
        path: '/count/:id',
        component: () => import('@/views/count'),
        meta: {title: '人员统计', Auth: true}
    },
    {
        path: '/404',
        component: () => import('@/views/404'),
        meta:{title:'404'}
    },
    { path: '*', redirect: '/404' }
]

const router = new VueRouter({
    routes
})

export default router
